var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18233 14.8791C11.089 12.3062 15.0268 10.6098 16.9957 9.79032C22.6239 7.45012 23.7919 7.04367 24.5548 7.02991C24.7225 7.02721 25.0961 7.06868 25.3398 7.26573C25.5424 7.43191 25.5994 7.65666 25.6278 7.81446C25.6532 7.9721 25.688 8.33137 25.6595 8.61183C25.3556 11.8152 24.0356 19.5889 23.3646 23.1769C23.0828 24.6951 22.5226 25.2041 21.9813 25.2538C20.8037 25.362 19.9111 24.4763 18.7715 23.7296C16.9894 22.5606 15.9828 21.8332 14.2513 20.6927C12.2507 19.3746 13.5486 18.65 14.6881 17.4662C14.9857 17.1563 20.1706 12.4414 20.2688 12.0137C20.2814 11.9602 20.2941 11.7608 20.1738 11.6557C20.0567 11.5503 19.8826 11.5864 19.756 11.6149C19.5755 11.6554 16.7298 13.5382 11.2093 17.2629C10.4021 17.8182 9.67091 18.0888 9.0125 18.0746C8.29078 18.059 6.89799 17.6656 5.8629 17.3294C4.59673 16.917 3.58695 16.6989 3.67559 15.9984C3.7199 15.6337 4.22321 15.2605 5.18233 14.8791Z",
    fill: "#2AABEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosTelegram);
export default __webpack_public_path__ + "static/media/logos_telegram.d7a5477c35c42efb1f6065af8105cc40.svg";
export { ForwardRef as ReactComponent };